/*
 * Окно звонка тёмное, как экран разговора в мессенджере: на светлом фоне кабинета видео
 * терялось бы, а белые круглые кнопки читались бы как обычные кнопки страницы. Цвета окна
 * собраны здесь, чтобы вход, разговор и свёрнутое окно не разошлись по оттенку.
 */
.incoming,
.conversation {
	--call-surface: var(--dark-primary-100);
	--call-ink: var(--white-secondary-100);
	--call-ink-soft: var(--white-secondary-60);
	--call-control: var(--white-secondary-10);
	--call-control-hover: var(--white-secondary-20);
	/* Ошибка — тёмно-красной плашкой: белый текст на фирменном красном читается хуже. */
	--call-alarm: #5c2023;
	position: fixed;
	z-index: 1250;
	box-sizing: border-box;
	background: var(--call-surface);
	color: var(--call-ink);
	border-radius: var(--Border-radius-XL);
	box-shadow: 0 16px 48px rgba(0, 0, 0, 0.32);
	animation: callAppear 0.2s ease-out;
}
@keyframes callAppear {
	from {
		opacity: 0;
		transform: translateY(12px) scale(0.98);
	}
}

/* Входящий звонок */
.incoming {
	right: 24px;
	top: calc(var(--chrome-height) + 16px);
	width: min(380px, calc(100vw - 32px));
	padding: 20px 20px 16px;
	display: flex;
	flex-direction: column;
	gap: 16px;
}
.incomingHead {
	display: flex;
	align-items: center;
	gap: 14px;
}
.incomingHead .callAvatar {
	width: 56px;
	height: 56px;
	font-size: 20px;
	/* Волна вокруг аватара — звонок звонит, пока его не приняли. */
	animation: callRing 1.6s ease-out infinite;
}
@keyframes callRing {
	from {
		box-shadow: 0 0 0 0 var(--brand-secondary-20);
	}
	to {
		box-shadow: 0 0 0 14px transparent;
	}
}
.incomingText {
	display: flex;
	flex-direction: column;
	gap: 2px;
	min-width: 0;
}
.incomingText strong {
	font-size: 17px;
	font-weight: 600;
	line-height: 1.3;
	overflow-wrap: anywhere;
}
.incomingText span {
	font-size: 13px;
	line-height: 1.45;
	color: var(--call-ink-soft);
	overflow-wrap: anywhere;
}
.incomingText .incomingKicker {
	font-size: 12px;
	letter-spacing: 0.02em;
}
.incomingActions {
	display: flex;
	justify-content: space-around;
}
.incomingProblem {
	margin: 0;
	font-size: 14px;
	line-height: 1.45;
}
.incomingButtons {
	display: flex;
	justify-content: flex-end;
	gap: 8px;
}

/* Окно разговора */
.conversation {
	/* Управление разговором выше cookie-баннера (1250), но ниже диалогов MUI (1300). */
	z-index: 1260;
	right: 24px;
	bottom: 24px;
	width: min(960px, calc(100vw - 48px));
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.callBar {
	display: flex;
	align-items: center;
	gap: 12px;
	min-height: 60px;
	padding: 12px 12px 12px 20px;
	box-sizing: border-box;
}
.barIdentity {
	flex: 1;
	min-width: 0;
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 0;
	border: 0;
	background: none;
	color: inherit;
	font: inherit;
	text-align: left;
	cursor: pointer;
}
.barIdentity:disabled {
	cursor: default;
}
.barText {
	display: flex;
	flex-direction: column;
	min-width: 0;
}
.barText strong,
.barText span {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.barText strong {
	font-size: 15px;
	font-weight: 600;
	line-height: 1.35;
}
.barText span {
	font-size: 12px;
	line-height: 1.4;
	color: var(--call-ink-soft);
	font-variant-numeric: tabular-nums;
}
.barSpacer {
	flex: 1;
}
.recordingPill {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	padding: 6px 12px;
	border-radius: 999px;
	background: var(--call-control);
	font-size: 12px;
	line-height: 1.3;
	white-space: nowrap;
}
/* Красная точка записи — привычный знак в вебе; на телефоне она белая (§8 ТЗ мобилки). */
.recordingDot {
	flex: 0 0 auto;
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: var(--danger-primary);
	animation: callRecording 2s ease-in-out infinite;
}
@keyframes callRecording {
	50% {
		opacity: 0.35;
	}
}
.barButton {
	flex: 0 0 auto;
	width: 36px;
	height: 36px;
	display: grid;
	place-items: center;
	padding: 0;
	border: 0;
	border-radius: 50%;
	background: var(--call-control);
	color: inherit;
	cursor: pointer;
	transition: background 0.15s;
}
.barButton:hover {
	background: var(--call-control-hover);
}
.body {
	position: relative;
	flex: 1 1 auto;
	min-height: 0;
	display: flex;
	flex-direction: column;
}
.stage {
	position: relative;
	flex: 1 1 auto;
	height: min(58vh, 540px);
	display: grid;
	place-items: center;
	overflow: hidden;
	/* Без своего фона: окно без видео — одна тёмная поверхность, как разговор в мессенджере.
	   Полосой середина выглядела бы пустым экраном между шапкой и кнопками; чёрное поле
	   появляется только под самим видео. */
}
/* display у середины задан, поэтому атрибут hidden сам её уже не прячет. */
.stage[hidden] {
	display: none;
}
/* У видео display не задаём: иначе атрибут hidden перестанет его прятать. */
.mainVideo {
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	/* Целиком, с полями: склад показывает товар, и обрезанный край кадра — потерянная деталь. */
	object-fit: contain;
	background: #000;
}
.insetVideo {
	position: absolute;
	right: 16px;
	bottom: 16px;
	z-index: 1;
	width: clamp(120px, 24%, 220px);
	aspect-ratio: 16 / 9;
	object-fit: cover;
	border-radius: var(--Border-radius-S);
	background: #000;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
}
.insetVideo[role='button'] {
	cursor: pointer;
	transition: box-shadow 0.15s;
}
.insetVideo[role='button']:hover,
.insetVideo[role='button']:focus-visible {
	box-shadow:
		0 0 0 2px var(--white-secondary-80),
		0 4px 16px rgba(0, 0, 0, 0.4);
	outline: none;
}
.mirrored {
	transform: scaleX(-1);
}
.identityBlock {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
	max-width: 480px;
	padding: 24px;
	text-align: center;
}
.callAvatar {
	flex: 0 0 auto;
	width: 96px;
	height: 96px;
	display: grid;
	place-items: center;
	border-radius: 50%;
	background: linear-gradient(135deg, var(--brand-secondary), var(--brand-primary));
	color: var(--white-secondary-100);
	font-size: 34px;
	font-weight: 600;
	letter-spacing: 0.02em;
	user-select: none;
}
.identityBlock .callAvatar {
	margin-bottom: 12px;
}
.callAvatarSmall {
	width: 32px;
	height: 32px;
	font-size: 12px;
}
.identityName {
	font-size: 22px;
	font-weight: 600;
	line-height: 1.3;
	overflow-wrap: anywhere;
}
.identityLine {
	font-size: 14px;
	line-height: 1.45;
	color: var(--call-ink-soft);
	overflow-wrap: anywhere;
}
.identityHeadline {
	margin-top: 12px;
	font-size: 18px;
	font-weight: 500;
	font-variant-numeric: tabular-nums;
}
.identityStatus {
	font-size: 14px;
	line-height: 1.45;
	color: var(--call-ink-soft);
}
.identityLine + .identityStatus {
	margin-top: 12px;
}
.identityNote {
	margin: 12px 0 0;
	padding: 10px 14px;
	border-radius: var(--Border-radius-S);
	background: var(--call-control);
	font-size: 13px;
	line-height: 1.45;
}
/* Сообщения — плашками над серединой окна, а не строками, сдвигающими видео. */
.notices {
	position: absolute;
	top: 12px;
	left: 16px;
	right: 16px;
	z-index: 2;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	pointer-events: none;
}
.callNotice {
	display: flex;
	align-items: center;
	gap: 12px;
	max-width: 100%;
	box-sizing: border-box;
	padding: 8px 14px;
	border-radius: var(--Border-radius-S);
	background: rgba(41, 40, 36, 0.88);
	backdrop-filter: blur(8px);
	color: var(--call-ink);
	font-size: 13px;
	line-height: 1.4;
	pointer-events: auto;
}
.callNotice:has(.callNoticeAction) {
	padding-right: 8px;
}
.callNoticeAlarming {
	background: var(--call-alarm);
}
.callNoticeAction {
	flex: 0 0 auto;
	padding: 6px 10px;
	border: 0;
	border-radius: var(--Border-radius-XXS);
	background: var(--white-secondary-20);
	color: var(--call-ink);
	font: inherit;
	font-weight: 500;
	white-space: nowrap;
	cursor: pointer;
	transition: background 0.15s;
}
.callNoticeAction:hover {
	background: var(--white-secondary-30);
}
/* Кнопки разговора */
.controls {
	display: flex;
	justify-content: center;
	align-items: flex-start;
	gap: 16px;
	padding: 16px 24px 20px;
}
.control {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	/* Ширина по подписи в пределах: «Отменить вызов» и «Сменить камеру» в 76px ломались
	   на две строки рядом с однострочными соседями. */
	min-width: 76px;
	max-width: 104px;
}
.controlFrame {
	position: relative;
	display: inline-flex;
}
.controlButton {
	width: 52px;
	height: 52px;
	display: grid;
	place-items: center;
	padding: 0;
	border: 0;
	border-radius: 50%;
	background: var(--call-control);
	color: var(--call-ink);
	cursor: pointer;
	transition:
		background 0.15s,
		transform 0.1s;
}
.controlButton svg {
	font-size: 24px;
}
.controlButton:hover:not(:disabled) {
	background: var(--call-control-hover);
}
.controlButton:active:not(:disabled) {
	transform: scale(0.94);
}
.controlButton:focus-visible,
.barButton:focus-visible,
.barIdentity:focus-visible,
.controlAccessory:focus-visible,
.callNoticeAction:focus-visible {
	outline: 2px solid var(--white-secondary-80);
	outline-offset: 2px;
}
.controlButton:disabled {
	opacity: 0.4;
	cursor: default;
}
.controlOn {
	background: var(--white-secondary-100);
	color: var(--dark-primary-100);
}
.controlOn:hover:not(:disabled) {
	background: var(--white-secondary-80);
}
.controlDanger {
	background: var(--danger-primary);
	color: var(--white-secondary-100);
}
.controlDanger:hover:not(:disabled) {
	background: var(--danger-secondary);
}
/* «Принять» синим, а не зелёным: белый значок на зелёном почти не виден. */
.controlAccept {
	background: var(--brand-primary);
	color: var(--white-secondary-100);
}
.controlAccept:hover:not(:disabled) {
	background: var(--brand-secondary);
}
.controlAccessory {
	position: absolute;
	right: -6px;
	bottom: -4px;
	width: 24px;
	height: 24px;
	display: grid;
	place-items: center;
	padding: 0;
	border: 2px solid var(--call-surface);
	border-radius: 50%;
	background: #4a4945;
	color: var(--call-ink);
	font-size: 16px;
	cursor: pointer;
}
.controlAccessory:hover {
	background: #5c5b57;
}
.controlLabel {
	font-size: 12px;
	line-height: 1.3;
	color: var(--call-ink-soft);
	text-align: center;
}
/*
 * Свёрнутое окно — карточка в углу: собеседник, его видео и три кнопки без подписей.
 * В чате угол занят «Отправить», поэтому карточка стоит над полем сообщения: высоту поля
 * сообщает сам композер (--composer-clearance, components/chat/MessageComposer).
 */
.compact {
	bottom: calc(12px + var(--composer-clearance, 12px));
	width: 360px;
	max-width: calc(100vw - 32px);
}
.compact .callBar {
	min-height: 0;
	padding: 10px 10px 10px 12px;
	gap: 8px;
}
.compact .recordingPill {
	padding: 6px;
}
.compact .stage {
	height: 200px;
	cursor: pointer;
}
.compact .insetVideo {
	right: 8px;
	bottom: 8px;
	width: 96px;
}
.compact .notices {
	position: static;
	padding: 0 12px 8px;
}
.compact .stage:not([hidden]) + .notices {
	padding-top: 8px;
}
.compact .controls {
	gap: 12px;
	padding: 4px 12px 12px;
}
.compact .control {
	width: auto;
}
.compact .controlButton {
	width: 44px;
	height: 44px;
}
.compact .controlButton svg {
	font-size: 22px;
}
/* «Звонок» в шапке чата и объяснение, почему позвонить нельзя */
.callButton {
	display: inline-flex;
}
/* Повтор класса сохраняет оформление поверх специфичности MUI Paper. */
.unavailable.unavailable {
	width: min(340px, calc(100vw - 32px));
	box-sizing: border-box;
	padding: 16px 20px;
	display: flex;
	flex-direction: column;
	gap: 8px;
	border-radius: var(--Border-radius-M);
	box-shadow:
		0 1px 3px rgba(0, 0, 0, 0.04),
		0 4px 24px rgba(0, 0, 0, 0.08);
}
.unavailable strong {
	font-size: 15px;
	font-weight: 600;
	line-height: 1.35;
}
.unavailable p {
	margin: 0;
	font-size: 13px;
	line-height: 1.45;
	color: var(--text-secondary);
}
.unavailableActions {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-end;
	gap: 8px;
	margin-top: 8px;
}
.deviceMenu.deviceMenu {
	min-width: 260px;
	max-width: 360px;
	border-radius: var(--Border-radius-S);
}
.deviceMenu li {
	gap: 10px;
	white-space: normal;
}
.invisible {
	visibility: hidden;
}
/* Повтор класса сохраняет оформление окна поверх специфичности MUI Paper. */
.notice.notice {
	position: relative;
	width: 373px;
	padding: 24px;
	border-radius: var(--Border-radius-M);
	box-shadow:
		0 1px 3px rgba(0, 0, 0, 0.04),
		0 4px 24px rgba(0, 0, 0, 0.08);
}
.notice h2 {
	font-size: 20px;
	font-weight: 500;
	line-height: 1.1;
	letter-spacing: 0;
	color: var(--text-constant-dark);
	margin: 0 24px 12px 0;
}
.notice p {
	font-size: 14px;
	line-height: 1.2;
	letter-spacing: 0.01em;
	color: var(--text-secondary);
	margin: 0 0 24px;
}
.notice .noticeAction {
	font-weight: 400;
	letter-spacing: 0.01em;
}
.notice .noticeExplanation {
	font-size: 12px;
	line-height: 1.45;
	color: var(--text-secondary);
}
.notice button[aria-label='Закрыть'] {
	/* Иконка отстоит от края на 12px; область нажатия остаётся 32px. */
	top: 4px;
	right: 4px;
	font-size: 16px;
}
.notice .error {
	padding: 0;
	color: var(--text-error);
}
.srOnly {
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	overflow: hidden;
	clip-path: inset(50%);
	white-space: nowrap;
}
.card {
	display: inline-flex;
	align-items: center;
	gap: 12px;
	text-align: left;
	border-radius: var(--Border-radius-M);
	padding: 16px 20px;
	background: var(--bg-dark-quartiary);
	color: var(--text-constant-dark);
	font-size: 14px;
}
.cardMissed {
	color: var(--text-error);
}
.cardDetails {
	display: flex;
	flex-direction: column;
	gap: 4px;
}
.cardDetails small {
	color: var(--text-secondary);
	font-size: 13px;
}
@media (max-width: 767px) {
	.incoming {
		/* Нижняя часть чата остаётся доступной для ввода сообщения. */
		top: calc(var(--chrome-height) + 12px);
		right: 12px;
		left: 12px;
		width: auto;
	}
	/* На телефоне развёрнутый разговор — весь экран, как звонок в мессенджере. */
	.conversation:not(.compact) {
		inset: 0;
		width: 100%;
		height: 100dvh;
		border-radius: 0;
		animation: none;
	}
	.conversation:not(.compact) .callBar {
		padding: calc(8px + env(safe-area-inset-top)) 12px 8px 16px;
	}
	.conversation:not(.compact) .stage {
		height: auto;
	}
	.conversation:not(.compact) .controls {
		gap: 4px;
		padding: 16px 8px calc(16px + env(safe-area-inset-bottom));
	}
	.conversation:not(.compact) .control {
		min-width: 64px;
	}
	.conversation:not(.compact) .insetVideo {
		top: 12px;
		bottom: auto;
		width: 30%;
		aspect-ratio: 3 / 4;
	}
	/* Рядом с именем собеседника подпись записи на узком экране не помещается — остаётся точка. */
	.callBar:has(.barIdentity) .recordingPill {
		/* Круг с точкой: без размеров и без промежутка под пропавшую подпись от плашки
		   оставался пустой овал. */
		width: 28px;
		height: 28px;
		justify-content: center;
		gap: 0;
		padding: 0;
		font-size: 0;
	}
	/* «Звонок» в шапке чата — одна трубка, как в шапке мессенджера: рядом с «Позвать
	   поддержку» подписи не хватало места, и название чата сжималось до трёх букв.
	   Подпись остаётся для скринридера. */
	.callButton button {
		width: 44px;
		padding: 0;
	}
	.callButtonLabel {
		position: absolute;
		width: 1px;
		height: 1px;
		overflow: hidden;
		clip-path: inset(50%);
		white-space: nowrap;
	}
	.compact {
		right: 12px;
		left: 12px;
		bottom: calc(8px + var(--composer-clearance, 4px));
		width: auto;
		max-width: none;
	}
}
@media (prefers-reduced-motion: reduce) {
	.incoming,
	.conversation,
	.incomingHead .callAvatar,
	.recordingDot {
		animation: none;
	}
}
